const Links = [
  'https://shy-top-coat-eel.cyclic.app',
  ];
export default Links;
